// extracted by mini-css-extract-plugin
export default {"componentWrapper":"AddCartForm_componentWrapper__f0nuX","actions":"AddCartForm_actions__xtRbX"};